// extracted by mini-css-extract-plugin
module.exports = {"geosuggest-popup":"_025a50318d--geosuggest-popup--j8epB","suggestion-list":"_025a50318d--suggestion-list--NRzbC"};